export default {"src":"/_next/static/media/Coast_Logo_Combo.a80dd1fa.svg","height":905,"width":3500,"blurWidth":0,"blurHeight":0};